module.exports = __webpack_public_path__ + "static/arkosLogo-55770059bc13b9c6df6f0e20deb269c7.svg";